import { request } from '../request';

export const mcpApi = {
  listMCPClients: () => request('/mcp'),

  getMCPClient: (clientKey) => request(`/mcp/${encodeURIComponent(clientKey)}`),

  createMCPClient: (body) =>
    request('/mcp', {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  updateMCPClient: (clientKey, body) =>
    request(`/mcp/${encodeURIComponent(clientKey)}`, {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  toggleMCPClient: (clientKey) =>
    request(`/mcp/${encodeURIComponent(clientKey)}/toggle`, {
      method: 'PATCH'
    }),

  deleteMCPClient: (clientKey) =>
    request(`/mcp/${encodeURIComponent(clientKey)}`, {
      method: 'DELETE'
    })
};
